import { useState } from "react";
import { useCookies } from "react-cookie";
import { store } from "../store/store";

export const useQalortSession = () => {
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [qalortUser, setUser] = useState(cookies.user || null);
  const state = store.getState();
  const user = state.user?.userData;

  let cookieOptions = {
    path: "/",
  };

  const updateUser = (data) => {
    setUser(data);
    setCookie("user", JSON.stringify(data), cookieOptions);
  };

  const removeUser = () => {
    setUser(null);
    removeCookie("user", cookieOptions);
  };

  return {
    updateUser,
    removeUser,
    // qalortUser,
    qalortUser: user,
  };
};
